import React,{useEffect, useState} from 'react'
import TableHeading from '../../Components/common/table/Tableheading'
import { showData } from '../../Utils/APIs/commonShowAPI'
import { insertData } from '../../Utils/APIs/commonInsertAPI';
const DailyPunchList = () => {
    const [dailyPunchList, setDailyPunchList] = useState([]);
    const [deletePunch, setDeletePunch] = useState(false);
    const [blockPunch, setBlockPunch] = useState(false);

    const headingList = [
        "SR No",
        "Name",
        "Punching Time",
        "Punch out Time",
        "Contact",
        "#",
        "#",
    ]    
    useEffect(() => {
        const fetchData = async () => {
            await showData("track/dailyPunchList",setDailyPunchList);
        }
        fetchData();
        setBlockPunch(false);
        setDeletePunch(false);
    }, [deletePunch, blockPunch]);
    const handleBlock = async (id) => {
        if (!id) {
            alert("Employee not punched in today.");
            return;
        }
        try {
            const response = await insertData("track/blockPunch/", setBlockPunch, {id});
            if (response) {
                alert("User blocked successfully for today.");
            }
        } catch (error) {
            console.error("Error blocking user:", error);
        }
    };
    const handleRePunch = async (id) => {
        if (!id) {
            alert("Employee not punched in today.");
            return;
        }
        try {
            await insertData("track/deletePunch", setDeletePunch, {id});
        } catch (error) {
            console.error("Error re-punching user:", error);
        }
    }

return (
    <div className='w-full h-full flex flex-col items-center justify-center'>
        <table className='w-full h-full border border-gray-200'>
            <TableHeading list={headingList} />
            <tbody className='text-center text-ellipsis overflow-hidden text-black whitespace-nowrap'>
                {dailyPunchList.map((item, index) => (
                    <tr key={index} className='border-b border-gray-200 hover:bg-gray-100'>
                        <td className='px-4 py-2'>{index + 1}</td>
                        <td className='px-4 py-2'>{item.name}</td>
                        <td
                            className={`px-4 py-2 ${
                                item?.punchData?.punchDate ? 'bg-green-200' : 'bg-red-200'
                            }`}
                        >
                            {item?.punchData?.punchDate
                                ? new Date(item.punchData.punchDate).toLocaleTimeString('en-US', { hour12: false }) // Convert to local time
                                : 'Not Punched In'}
                        </td>
                        <td className='px-4 py-2'>
                            {item?.punchData?.punchOut.length > 0
                                ? new Date(item.punchData.updatedAt).toLocaleTimeString('en-US', { hour12: false }) // Convert to local time
                                : 'Not Punched Out'}
                        </td>
                        <td className='px-4 py-2'>{item.contact}</td>
                        <td className='px-4 py-2'>
                            <button 
                                className='bg-blue-500 text-white px-2 py-1 rounded'
                                onClick={() => handleRePunch(item?.punchData?._id)}
                            >
                                Re-Punch
                            </button>
                        </td>
                        <td className='px-4 py-2'>
                            {!item?.punchData?.isBlocked &&<button
                                className='bg-red-500 text-white px-2 py-1 rounded'
                                onClick={() => handleBlock(item?.punchData?._id)}
                            >
                                Block
                            </button>}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
}

export default DailyPunchList